import { DRAG_THRESHOLD_PX, PRIMARY_MOUSE_BUTTON } from "./constants";
import { createEventManager } from "./eventManager";
import { supportsFinePointer } from "./mediaQueries";

export const createDragController = ({ element, win, onInteraction }) => {
  if (!supportsFinePointer(win)) {
    return {
      destroy: () => {},
    };
  }

  const events = createEventManager();
  let isDragging = false;
  let hasDragged = false;
  let startPointerY = 0;
  let startScrollTop = 0;

  const stopDragging = () => {
    isDragging = false;
    element.classList.remove("cursor-grabbing", "select-none");
    element.classList.add("cursor-grab");
  };

  element.classList.add("cursor-grab");

  events.add(element, "pointerdown", (event) => {
    if (event.button !== PRIMARY_MOUSE_BUTTON) {
      return;
    }

    onInteraction();
    isDragging = true;
    hasDragged = false;
    startPointerY = event.clientY;
    startScrollTop = element.scrollTop;
    element.classList.remove("cursor-grab");
    element.classList.add("cursor-grabbing", "select-none");
    element.setPointerCapture(event.pointerId);
  });

  events.add(element, "pointermove", (event) => {
    if (!isDragging) {
      return;
    }

    const dragDistance = event.clientY - startPointerY;

    if (Math.abs(dragDistance) > DRAG_THRESHOLD_PX) {
      hasDragged = true;
    }

    element.scrollTop = startScrollTop - dragDistance;
  });

  events.add(element, "pointerup", (event) => {
    if (element.hasPointerCapture(event.pointerId)) {
      element.releasePointerCapture(event.pointerId);
    }

    stopDragging();
  });

  events.add(element, "pointercancel", stopDragging);

  events.add(element, "dragstart", (event) => {
    event.preventDefault();
  });

  events.add(
    element,
    "click",
    (event) => {
      if (!hasDragged) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      hasDragged = false;
    },
    true
  );

  return {
    destroy: () => {
      stopDragging();
      element.classList.remove("cursor-grab");
      events.cleanup();
    },
  };
};
